// extracted by mini-css-extract-plugin
module.exports = {"courses":"courses-module--courses--3YA2R"};